<div class="min-h-screen flex">

  <!-- ══════ Panel izquierdo: Marca (visible solo en lg+) ══════ -->
  <aside class="hidden lg:flex lg:w-[42%] xl:w-2/5 relative overflow-hidden bg-neutral-950 flex-col items-center justify-center">

    <!-- Imagen de fondo con opacidad muy baja -->
    <img
      src="https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?q=80&w=2021&auto=format&fit=crop"
      alt="" aria-hidden="true"
      class="absolute inset-0 w-full h-full object-cover opacity-[0.14]"
    />
    <!-- Gradiente de profundidad -->
    <div class="absolute inset-0 bg-linear-to-b from-neutral-950/70 via-transparent to-neutral-950/80"></div>

    <!-- Contenido de marca -->
    <div class="relative z-10 flex flex-col items-center text-center px-12 max-w-70">

      <!-- Logo -->
      <div class="w-18 h-18 rounded-2xl bg-white/8 border border-white/10 flex items-center justify-center mb-8 backdrop-blur-sm">
        <img ngSrc="/images/app-portal-icon.png" width="82" height="42" [alt]="brandLogoAlt" class="w-10.5 h-auto object-contain" priority />
      </div>

      <h1 class="text-3xl font-bold text-white tracking-tight leading-tight mb-3">
        {{ brandName }}
      </h1>
      <p class="text-neutral-400 text-sm leading-relaxed">
        {{ brandTagline }}
      </p>

      <!-- Decorativo -->
      <div class="flex items-center gap-2 mt-10">
        <span class="w-8 h-px bg-white/15"></span>
        <span class="w-1 h-1 rounded-full bg-white/40"></span>
        <span class="w-8 h-px bg-white/15"></span>
      </div>
    </div>
  </aside>

  <!-- ══════ Panel derecho: Formulario ══════ -->
  <main class="flex-1 flex items-center justify-center p-8 sm:p-12 bg-white dark:bg-neutral-950">
    <div class="w-full max-w-85">

      <!-- Logo compacto (móvil y tablet) -->
      <div class="flex lg:hidden justify-center mb-10">
        <div class="w-12 h-12 max-sm:w-72 max-sm:h-72 rounded-xl max-sm:rounded-2xl bg-neutral-900 flex items-center justify-center">
          <img ngSrc="/images/app-portal-icon.png" width="202" height="162" [alt]="brandLogoAlt" class="w-7 max-sm:w-62 h-auto object-contain" priority />
        </div>
      </div>

      <!-- Cabecera -->
      <div class="mb-7">
        <h2 class="text-xl font-semibold text-neutral-900 dark:text-white tracking-tight">Iniciar sesión</h2>
        <p class="text-sm text-neutral-500 dark:text-neutral-400 mt-1">Bienvenido de nuevo a {{ brandName }}</p>
      </div>

      <!-- Formulario -->
      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="space-y-4">

        <!-- Campo: Email -->
        <div class="flex flex-col gap-1.5">
          <label for="email" class="text-sm font-medium text-neutral-700 dark:text-neutral-300">Correo electrónico</label>
          <p-iconfield class="w-full">
            <p-inputicon class="pi pi-envelope" />
            <input
              pInputText id="email" type="email"
              formControlName="email" autocomplete="email"
              placeholder="tu@correo.com"
              class="w-full"
            />
          </p-iconfield>
          @if (email.invalid && (email.dirty || email.touched)) {
            <small class="text-red-500 text-xs flex items-center gap-1">
              <i class="pi pi-exclamation-circle"></i>
              @if (email.errors?.['required']) { El correo es requerido }
              @else { Ingresa un correo válido }
            </small>
          }
        </div>

        <!-- Campo: Contraseña -->
        <div class="flex flex-col gap-1.5">
          <div class="flex items-center justify-between">
            <label for="password" class="text-sm font-medium text-neutral-700 dark:text-neutral-300">Contraseña</label>
            <a
              [routerLink]="['/auth/forgot-password']"
              class="text-xs text-neutral-500 dark:text-neutral-400 hover:text-neutral-900 dark:hover:text-neutral-200 transition-colors cursor-pointer"
            >
              ¿Olvidaste tu contraseña?
            </a>
          </div>
          <p-password
            id="password" formControlName="password"
            autocomplete="current-password" placeholder="Tu contraseña"
            [feedback]="false" [toggleMask]="true"
            styleClass="w-full" inputStyleClass="w-full"
          />
          @if (password.invalid && (password.dirty || password.touched)) {
            <small class="text-red-500 text-xs flex items-center gap-1">
              <i class="pi pi-exclamation-circle"></i>
              La contraseña es requerida
            </small>
          }
        </div>

        <!-- Botón principal -->
        <div class="pt-1">
          <p-button
            type="submit" label="Iniciar sesión"
            [loading]="isSubmitting()" [disabled]="loginForm.invalid"
            [fluid]="true" severity="contrast"
          />
        </div>

        @if (authStore.loginFeedback(); as fb) {
          @if (fb.accountLocked) {
            <div class="mt-3 rounded-lg border border-red-200 dark:border-red-800 bg-red-50 dark:bg-red-950/30 p-3 space-y-1.5">
              <p class="text-red-700 dark:text-red-400 text-[11px] font-medium leading-snug flex items-start gap-1.5" role="alert">
                <i class="pi pi-lock mt-0.5 shrink-0" aria-hidden="true"></i>
                <span>{{ fb.message }}</span>
              </p>
              <a
                [routerLink]="['/auth/forgot-password']"
                class="inline-flex items-center gap-1 text-[11px] font-semibold text-red-700 dark:text-red-400 underline underline-offset-2 hover:text-red-900 dark:hover:text-red-300 transition-colors"
              >
                Restablecer contraseña →
              </a>
            </div>
          } @else {
            <p
              class="text-red-600 dark:text-red-400 text-[11px] leading-snug mt-3 flex items-start gap-1"
              role="status"
            >
              <i class="pi pi-exclamation-circle mt-0.5 shrink-0" aria-hidden="true"></i>
              <span>{{ fb.message }}</span>
            </p>
          }
        }

      </form>

      <!-- Separador Google -->
      <div class="flex items-center gap-3 my-6">
        <div class="flex-1 h-px bg-neutral-100 dark:bg-neutral-800"></div>
        <span class="text-xs text-neutral-400 dark:text-neutral-500">o continúa con</span>
        <div class="flex-1 h-px bg-neutral-100 dark:bg-neutral-800"></div>
      </div>

      <!-- Botón Google Identity Services -->
      <button
        type="button"
        (click)="onGoogleSignIn()"
        class="w-full flex items-center justify-center gap-3 px-4 py-2.5 rounded-lg border border-neutral-200 dark:border-neutral-700 bg-white dark:bg-neutral-900 hover:bg-neutral-50 dark:hover:bg-neutral-800 transition-colors text-sm font-medium text-neutral-700 dark:text-neutral-200 cursor-pointer"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="18" height="18" aria-hidden="true">
          <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
          <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
          <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
          <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
        </svg>
        Iniciar sesión con Google
      </button>
      <!-- Pie -->
      <p class="text-center text-[11px] text-neutral-400 dark:text-neutral-500 mt-10">
        {{ brandFooterLine }}
      </p>

    </div>
  </main>

</div>
